import { render, staticRenderFns } from "./InstallInstructionsList.vue?vue&type=template&id=b6f1c26c"
import script from "./InstallInstructionsList.vue?vue&type=script&lang=js"
export * from "./InstallInstructionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports